const { RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { image, title, description } = attributes;

  return (
    <div className="SolutionSection-accordion-item swiper-slide">
      <figure className="SolutionSection-accordion-item-image margin-extra-small">
        <img
          src={image.src}
          title={image.alt}
          width={image.width}
          height={image.height}
          alt={image.alt}
          class="SolutionSection-accordion-item-image"
        />
      </figure>

      <div className="SolutionSection-accordion-item-content">
        <RichText.Content
          tagName="h3"
          value={title}
          className="Typography subtitle left color-blue-dark margin-extra-small"
        />
        <RichText.Content
          tagName="p"
          value={description}
          className="Typography text left color-grey margin-none"
        />
      </div>
    </div>
  );
};

export default Save;
